
import { defineComponent, ref, onMounted } from "vue";
import { usePlugin } from "@/plugins";
import {
  ConfigQuestionSet,
  GetConfigQuestionSetResponse,
  UpsertConfigQuestionSetRequest,
  UpsertConfigUserRequest,
  TrainingTypeEnum,
} from "@/types";
import InputQuestion from "@/components/InputQuestion.vue";

export default defineComponent({
  name: "ConfigQuestionSetScreen",
  components: { InputQuestion },
  setup() {
    const { setLoading, error, success, axios, trainingTypeDesc } = usePlugin();
    const configs = ref<ConfigQuestionSet[]>([]);

    const loadDocument = async () => {
      setLoading(true);
      try {
        const result = await axios.post<GetConfigQuestionSetResponse>(
          "api/v1/services/configQuestionSet",
          {}
        );

        configs.value = result.data.configQuestionSets ?? [];
        success("ดึงข้อมูลสำเร็จแล้ว");
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onSaveDocument = async () => {
      setLoading(true);
      try {
        await axios.post("api/v1/services/configQuestionSet/upsert", {
          questionSets: configs.value,
        } as UpsertConfigQuestionSetRequest);
        success("บันทึกข้อมูลสำเร็จแล้ว");
        loadDocument();
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const isTrainingType = (input: TrainingTypeEnum) => {
      return [
        TrainingTypeEnum.Internal,
        TrainingTypeEnum.External,
        TrainingTypeEnum.SiteVisit,
      ].includes(input);
    };

    const isPositionType = (input: TrainingTypeEnum) => {
      return [
        TrainingTypeEnum.NewEmployee,
        TrainingTypeEnum.Transfer,
        TrainingTypeEnum.Promote,
      ].includes(input);
    };

    onMounted(() => loadDocument());

    return {
      configs,
      trainingTypeDesc,
      onSaveDocument,
      isTrainingType,
      isPositionType,
    };
  },
});
